export enum EntityUrlEnum{
  CASE = "/ui/td/cases/",
  STEPS = "/steps"
}
